import React from 'react'

const SVG = ({
  style = {},
  fill = '#FFFFFF',
  width = '100%',
  height = '100%',
  className = '',
  viewBox = '0 0 11.107 14.81'
}) => (
  <svg
    width={width}
    style={style}
    height={height}
    viewBox={viewBox}
    xmlns='http://www.w3.org/2000/svg'
    className={`svg-icon ${className || ''}`}
  >

    <path
      fill={fill}
      d='M4.983,14.511C0.78,8.418,0,7.793,0,5.554
	c0.041-3.067,2.561-5.52,5.628-5.479c3.009,0.04,5.439,2.47,5.479,5.479c0,2.239-0.78,2.865-4.983,8.957
	c-0.224,0.315-0.661,0.39-0.976,0.166C5.084,14.631,5.028,14.575,4.983,14.511L4.983,14.511z M5.554,7.868
	c1.278,0,2.314-1.036,2.314-2.314S6.832,3.24,5.554,3.24S3.24,4.276,3.24,5.554l0,0C3.24,6.832,4.276,7.868,5.554,7.868L5.554,7.868
	z'
    />
  </svg>
)

export default SVG
